import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import * as userActions from 'modules/user';
import * as loginActions from 'modules/login';

import { AlreadyLogin } from 'components';
import { clearReduxStore } from 'containers/InitialStore';

class CtAlreadyLogin extends Component {
  constructor(props) {
    super(props);

    this.onMoveBack = this.onMoveBack.bind(this);
    this.onLogout = this.onLogout.bind(this);
  }

  // 돌아가기
  onMoveBack = () => {
    const { mainPage } = this.props;

    return window.location.replace(mainPage);
  };

  // 로그아웃
  onLogout = async () => {
    const { UserActions, LoginActions, accessLevel } = this.props;

    localStorage.removeItem('loginAdmin');
    localStorage.removeItem('loginUser');
    sessionStorage.removeItem('curUser');
    // 로그아웃 처리
    await UserActions.logout();
    // 로그인 초기화
    LoginActions.setInitial();
    if (accessLevel === 2) {
      return window.location.replace('/mudlogin');
    } else {
      return window.location.replace('/login');
    }
  };

  render() {
    const { onMoveBack, onLogout } = this;
    const { mainPage } = this.props;
    return <AlreadyLogin mainPage={mainPage} onMoveBack={onMoveBack} onLogout={onLogout} />;
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  UserActions: bindActionCreators(userActions, dispatch),
  LoginActions: bindActionCreators(loginActions, dispatch),
  Dispatch: dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(CtAlreadyLogin);



// WEBPACK FOOTER //
// ./src/script/containers/login/CtAlreadyLogin.js